import { api } from "../utils/api";
import type {
  RestCreateSupplier,
  RestSupplier,
  RestUpdateSupplier,
} from "@KassaroAB/shared/types/supplier";
import type { SupplierId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const suppliersPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "suppliers");

export const getSuppliersApi = (
  scope: CatalogScope,
): Promise<RestSupplier[]> => {
  return api.get(suppliersPath(scope));
};

export const getSupplierApi = (
  scope: CatalogScope,
  supplierId: SupplierId,
): Promise<RestSupplier> => {
  return api.get(`${suppliersPath(scope)}/${supplierId}`);
};

export const createSupplierApi = (
  scope: CatalogScope,
  supplier: RestCreateSupplier,
): Promise<RestSupplier> => {
  return api.post(suppliersPath(scope), supplier);
};

export const updateSupplierApi = (
  scope: CatalogScope,
  supplierId: SupplierId,
  supplier: RestUpdateSupplier,
): Promise<RestSupplier> => {
  return api.put(`${suppliersPath(scope)}/${supplierId}`, supplier);
};

export const deleteSupplierApi = (
  scope: CatalogScope,
  supplierId: SupplierId,
): Promise<void> => {
  return api.delete(`${suppliersPath(scope)}/${supplierId}`);
};
